// extracted by mini-css-extract-plugin
module.exports = {"content_div":"PlayerInfoModal_content_div__36ZtB","member_profile":"PlayerInfoModal_member_profile__25Qsd","style_a":"PlayerInfoModal_style_a__2bv59"};